import React from 'react';

export const FollowUpIcon = ({ className = "h-4 w-4" }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_follow_up)">
      <path
        d="M9.5 14C11.71 14 13.5 12.21 13.5 10C13.5 7.79 11.71 6 9.5 6C7.29 6 5.5 7.79 5.5 10C5.5 12.21 7.29 14 9.5 14ZM9.5 8C10.6 8 11.5 8.9 11.5 10C11.5 11.1 10.6 12 9.5 12C8.4 12 7.5 11.1 7.5 10C7.5 8.9 8.4 8 9.5 8Z"
        fill="#0B0C10"
        fillOpacity="0.8"
      />
      <path
        d="M15.89 16.56C14.21 15.7 12.03 15 9.5 15C6.97 15 4.79 15.7 3.11 16.56C2.11 17.07 1.5 18.1 1.5 19.22V22H17.5V19.22C17.5 18.1 16.89 17.07 15.89 16.56ZM15.5 20H3.5V19.22C3.5 18.84 3.7 18.5 4.02 18.34C5.21 17.73 7.13 17 9.5 17C11.87 17 13.79 17.73 14.98 18.34C15.3 18.5 15.5 18.84 15.5 19.22V20Z"
        fill="#0B0C10"
        fillOpacity="0.8"
      />
      <path
        d="M19.8272 8.18918C19.8272 6.37248 19.1369 3.95357 17.2728 2.28429C14.6746 -0.0421777 10.9629 -0.315451 8.09548 1.33521L9.02384 2.95177C11.2065 1.69474 14.0385 1.90501 16.022 3.68113C17.6164 5.10882 18 6.99995 17.9421 8.29316L15.1083 8.50464L19.1369 12.0075L22.6398 7.97887L19.8272 8.18918Z"
        fill="#0B0C10"
        fillOpacity="0.8"
      />
    </g>
    <defs>
      <clipPath id="clip0_follow_up">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const WIPTicketIcon = ({ className = "h-4 w-4" }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="4" y="6" width="16" height="12" rx="2" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    <text x="12" y="13" textAnchor="middle" fontSize="8" fontWeight="bold" fill="currentColor">WIP</text>
  </svg>
);

export const RoutingSettingsIcon = ({ className = "h-4 w-4" }: { className?: string }) => (
  <svg
  className={className}
  viewBox="0 0 26 26" 
  fill="none" 
  xmlns="http://www.w3.org/2000/svg">
<path d="M9.78 11.16L8.36 12.58C7.68 11.89 7.02 11 6.57 9.64L8.51 9.15C8.83 10.04 9.28 10.65 9.78 11.16ZM11 6L7 2L3 6H6.02C6.04 6.81 6.1 7.54 6.21 8.17L8.15 7.68C8.08 7.2 8.03 6.63 8.02 6H11ZM21 6L17 2L13 6H15.99C15.89 9.68 14.71 10.75 13.45 11.88C12.95 12.32 12.44 12.8 12 13.43C11.66 12.94 11.27 12.55 10.87 12.19L9.46 13.6C10.39 14.45 11 15.14 11 17V22H13V17C13 14.98 13.71 14.34 14.79 13.37C16.17 12.13 17.87 10.59 17.99 6H21Z" fill="currentColor"/>
</svg>

);

export const LeadScoreIcon = ({ className = "h-4 w-4" }: { className?: string }) => (
<svg 
className={className}
viewBox="0 0 19 16" 
fill="none" 
xmlns="http://www.w3.org/2000/svg">
<path d="M16 13H18V13.5H17V14.5H18V15H16V16H19V12H16V13ZM17 4H18V0H16V1H17V4ZM16 7H17.8L16 9.1V10H19V9H17.2L19 6.9V6H16V7ZM0 1H14V3H0V1ZM0 13H14V15H0V13ZM0 7H14V9H0V7Z" fill="currentColor"/>
</svg>

);

export const AnalyticsIcon = ({ className = "h-4 w-4" }: { className?: string }) => (
<svg
className={className}
viewBox="0 0 24 24" 
fill="none" 
xmlns="http://www.w3.org/2000/svg">
<path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z" fill="currentColor"/>
<path d="M9 12H7V17H9V12Z" fill="currentColor"/>
<path d="M17 7H15V17H17V7Z" fill="currentColor"/>
<path d="M13 14H11V17H13V14Z" fill="currentColor"/>
<path d="M13 10H11V12H13V10Z" fill="currentColor"/>
</svg>


);

export const TrophyIcon = ({ className = "h-4 w-4" }: { className?: string }) => (
  <svg className={className} width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.794 1.19999V2.33333C10.794 4.17399 9.30217 5.66666 7.46252 5.66666H6.99609L7.51381 5.13266C9.03366 5.10532 10.261 3.86 10.261 2.33333V1.46668H8.26209L8.32873 0.93335H10.5275C10.6748 0.933303 10.794 1.05265 10.794 1.19999Z" fill="#E8A615"/>
    <path d="M7.12934 8.87806V9.46672H3.66455V8.87806C3.66455 8.83007 3.69053 8.78539 3.73251 8.76207L3.99504 8.61407C4.44945 8.35808 4.73064 7.87742 4.73064 7.3554V6.7334H6.06325V7.3554C6.06325 7.87739 6.34444 8.35806 6.79885 8.61407L7.06138 8.76207C7.10336 8.78539 7.12934 8.83007 7.12934 8.87806Z" fill="#E8A615"/>
    <path d="M7.12921 8.87806V9.46672H6.79607V8.87806C6.79607 8.83007 6.77009 8.78539 6.72811 8.76207L6.46558 8.61407C6.01117 8.35808 5.72998 7.87742 5.72998 7.3554V6.7334H6.06314V7.3554C6.06314 7.87739 6.34433 8.35806 6.79874 8.61407L7.06128 8.76207C7.10323 8.78539 7.12921 8.83007 7.12921 8.87806Z" fill="#B7791D"/>
    <path d="M6.46326 6.21338V6.60004C6.46326 6.78404 6.31401 6.93337 6.13009 6.93337H4.66422C4.48032 6.93337 4.33105 6.78404 4.33105 6.60004V6.21338H6.46326Z" fill="#E8A615"/>
    <path d="M6.06357 6.93335H4.73096V7.12936H6.06357V6.93335Z" fill="#B7791D"/>
    <path d="M7.66271 9.3334V11.6667H3.13184V9.3334C3.13184 9.26007 3.19181 9.20007 3.2651 9.20007H7.52945C7.60276 9.20007 7.66271 9.26007 7.66271 9.3334Z" fill="#343B49"/>
    <path d="M7.66248 9.3334V11.6667H7.39596V9.3334C7.39596 9.26007 7.33598 9.20007 7.2627 9.20007H7.52922C7.60252 9.20007 7.66248 9.26007 7.66248 9.3334Z" fill="#262D38"/>
    <path d="M8.06237 11.6V11.8667C8.06237 11.94 8.0024 12 7.92911 12H2.86519C2.79191 12 2.73193 11.94 2.73193 11.8667V11.6C2.73193 11.5267 2.79191 11.4667 2.86519 11.4667H7.92911C8.00242 11.4667 8.06237 11.5267 8.06237 11.6Z" fill="#262D38"/>
    <path d="M8.06189 11.6V11.8667C8.06189 11.94 8.00191 12 7.92863 12H7.66211C7.73539 12 7.79537 11.94 7.79537 11.8667V11.6C7.79537 11.5267 7.73539 11.4667 7.66211 11.4667H7.92863C8.00194 11.4667 8.06189 11.5267 8.06189 11.6Z" fill="#171C23"/>
    <path d="M6.99612 9.86661V10.7999C6.99612 10.8733 6.93614 10.9333 6.86286 10.9333H3.93111C3.85783 10.9333 3.79785 10.8733 3.79785 10.7999V9.86661C3.79785 9.79328 3.85783 9.73328 3.93111 9.73328H6.86286C6.93616 9.73328 6.99612 9.79328 6.99612 9.86661Z" fill="#E8A615"/>
    <path d="M6.46297 6.21338V6.60004C6.46297 6.78404 6.31373 6.93337 6.1298 6.93337H5.86328C6.04718 6.93337 6.19645 6.78404 6.19645 6.60004V6.21338H6.46297Z" fill="#B7791D"/>
    <path d="M3.99783 5.66666H3.33153C1.49187 5.66666 0 4.17399 0 2.33333V1.20001C0 1.05267 0.119276 0.93335 0.266522 0.93335H2.46534V1.46668H0.533044V2.33333C0.533044 3.86 1.76039 5.10532 3.28023 5.13266L3.99783 5.66666Z" fill="#E8A615"/>
    <path d="M8.66214 0.400024V0.666687C8.66214 3.90667 7.20026 6.53334 5.39723 6.53334C3.59421 6.53334 2.13232 3.9067 2.13232 0.666687V0.400024H8.66214Z" fill="#E8A615"/>
    <path d="M2.16232 1.46668H1.8958C1.88247 1.29134 1.87381 1.11335 1.86914 0.93335H2.13566C2.14033 1.11333 2.14899 1.29134 2.16232 1.46668Z" fill="#B7791D"/>
    <path d="M3.68861 5.66662H3.42209C3.27351 5.50262 3.13224 5.31729 3.00098 5.11328C3.09294 5.12462 3.18553 5.13062 3.28017 5.13262C3.4081 5.32928 3.5447 5.50795 3.68861 5.66662Z" fill="#B7791D"/>
    <path d="M6.46323 6.21338V6.34671C6.12875 6.55405 5.77027 6.66671 5.39714 6.66671C5.02402 6.66671 4.66553 6.55405 4.33105 6.34671V6.21338C4.66553 6.42072 5.02402 6.53338 5.39714 6.53338C5.77027 6.53338 6.12875 6.42072 6.46323 6.21338Z" fill="#B7791D"/>
    <path d="M8.66193 0.400024V0.666687C8.66193 3.80535 7.28999 6.36868 5.56494 6.52602C7.24137 6.36669 7.86236 3.80404 7.86236 0.666687V0.400024H8.66193Z" fill="#B7791D"/>
    <path d="M8.99495 0.333329C8.99495 0.425337 8.95764 0.508664 8.89766 0.569322C8.83702 0.629324 8.75375 0.666657 8.66178 0.666657H2.13199C1.94809 0.666657 1.79883 0.517322 1.79883 0.333329C1.79883 0.24132 1.83614 0.157994 1.89612 0.0973352C1.95675 0.0373337 2.04003 0 2.13199 0H8.66181C8.84571 0 8.99495 0.149335 8.99495 0.333329Z" fill="#E8A615"/>
    <path d="M8.66214 0.666626C8.66214 0.755959 8.6608 0.844636 8.65881 0.933289H2.13566C2.13366 0.844612 2.13232 0.755959 2.13232 0.666626H8.66214Z" fill="#B7791D"/>
    <path d="M8.99482 0.333329C8.99482 0.425337 8.95751 0.508664 8.89753 0.569322C8.8369 0.629324 8.75362 0.666657 8.66166 0.666657H7.92871C8.02067 0.666657 8.10395 0.629324 8.16459 0.569322C8.22457 0.508664 8.26188 0.425314 8.26188 0.333329C8.26188 0.149335 8.11263 0 7.92871 0H8.66166C8.84558 0 8.99482 0.149335 8.99482 0.333329Z" fill="#B7791D"/>
    <path d="M6.99577 9.86663V10.8C6.99577 10.8733 6.9358 10.9333 6.86251 10.9333H4.21729C4.75566 10.9226 6.52937 10.808 6.52937 9.73328H6.86254C6.93582 9.7333 6.99577 9.7933 6.99577 9.86663Z" fill="#B7791D"/>
    <path d="M3.93115 10.4666V9.92111C3.93115 9.89098 3.95556 9.86658 3.98566 9.86658H5.18048C5.18048 9.86658 4.231 9.96659 3.93115 10.4666Z" fill="#FFCC66"/>
    <path d="M3.28125 9.93337V9.38791C3.28125 9.35778 3.30565 9.33337 3.33576 9.33337H4.53058C4.53058 9.33337 3.58107 9.43336 3.28125 9.93337Z" fill="#4E5868"/>
    <path d="M5.39706 6.33328C4.67345 6.33328 2.66654 4.80595 2.42334 1.19995H3.2149C3.41413 5.61195 5.39706 6.33328 5.39706 6.33328Z" fill="#FFCC66"/>
    <path d="M3.99756 8.93334C3.99756 8.93334 4.93039 8.33335 4.93039 7.46667V8.93334H3.99756Z" fill="#FFCC66"/>
    <path d="M2.26529 0.133301V0.333298H1.93213C1.93213 0.223291 2.02142 0.133301 2.13203 0.133301H2.26529Z" fill="#FFCC66"/>
    <path d="M8.85854 0.93335C8.85387 1.11335 8.84521 1.29134 8.83122 1.46668H8.26221L8.32885 0.93335H8.85854Z" fill="#B7791D"/>
    <path d="M7.7217 5.12134C7.59111 5.32199 7.45184 5.50467 7.30525 5.66668H6.99609L7.23197 5.42402L7.51381 5.1327C7.58379 5.13133 7.65308 5.12735 7.7217 5.12134Z" fill="#B7791D"/>
  </svg>
);
